import classNames from 'classnames';
import { Project } from 'data/projects';
import { useMemo } from 'react';

const useProjectProgress = (project: Project) => {
  const progress = useMemo(() => {
    return Math.ceil(
      ((project.progress?.progressMin ?? 0) /
        (project.progress?.progressMax ?? 1)) *
        100
    );
  }, [project]);

  const variant = useMemo(() => {
    return classNames({
      [`${project.status?.displayType}`]:
        project.status?.displayType !== 'secondary',
      '700': project.status?.displayType === 'secondary'
    });
  }, [project]);

  const bgClassName = useMemo(() => {
    return classNames({
      [`bg-${project.status?.displayType}-100`]:
        project.status?.displayType !== 'secondary',
      'bg-200': project.status?.displayType === 'secondary'
    });
  }, [project]);

  return { progress, variant, bgClassName };
};

export default useProjectProgress;
